import React from 'react'

function Loader() {
    return (
        <div class="loader">
            <div class="justify-content-center jimu-primary-loading"></div>
        </div>
    )
}

export default Loader